import ChangeNFT from 'contract/SwapLabsToShares.json';
import {useContract} from "Standard/hooks/useCommonContracts";
import {getChangeNFTContract} from "utils/getAddress";

export const useChangeNFTContract = () => {
	const abi = ChangeNFT.abi;
	return useContract(abi, getChangeNFTContract());
}